import { useState, type ReactElement } from 'react';
import { InputNumber, Modal } from 'antd';
import { Box } from '../../../box';
import { Button } from '../../../button';
import { useTranslation } from '../../../i18n';
import styles from '../style.module.less';
import { message } from '../../../feedback';
import type { EditScoreProps } from './types';

export function EditScoreModal(props: EditScoreProps): ReactElement {
  const { title, visible, maxScore, realScore, onCancel, onOk } = props;
  const [t] = useTranslation();
  const [score, setScore] = useState<number | null>(realScore);

  const onSubmit = async (): Promise<void> => {
    if (score == null || score > maxScore) {
      message.error(t('最高分：{maxScore}分', { maxScore }));
      return;
    }
    onOk(score);
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={() => onCancel()}
      footer={
        <Button
          type='primary'
          label={t('提交')}
          loading={props.loading}
          onClick={onSubmit}
        />
      }
    >
      <Box className={styles.editScoreBox}>
        <div className={styles.mb10} style={{ color: '#e44134' }}>
          {t('最高分：{maxScore}分', { maxScore })}
        </div>
        <InputNumber
          type='number'
          style={{ width: '100%' }}
          value={score}
          onChange={value => {
            setScore(value);
          }}
          placeholder={t('请输入得分')}
        />
      </Box>
    </Modal>
  );
}
